import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import MediaFormats from 'types/MediaFormats';
// Components
import MultiLanguageTextField from 'components/MultiLanguageTextField';
import ImageUpload from 'components/ImageUpload';
import { ColorPicker } from 'components/ColorPicker';
// Utilities
import { isMaxValue } from 'utilities/validation';
import { Toggle } from 'components/Controls';

const LandingPageForm:FC = () => {
  const { t } = useTranslation();

  const { control, formState: { errors }, watch } = useFormContext();

  const imageBackgroundColor = watch('landingPage.imageBackgroundColor');
  
  return (
    <div className="w-full flex flex-wrap -mx-6 -y-4 px-6 pb-3">
      <div className="w-full landscape:w-1/2 tablet:w-full laptop:w-7/12 px-6">
        <MultiLanguageTextField
          rules={{ validate: { maxLength: (value: string) => isMaxValue(value, 24) } }}
          name="landingPage.buttonTitle"
          label={t('labels.buttonTitle')}
          className="mb-4"
          error={errors.landingPage?.buttonTitle}
          errorText={errors.landingPage?.buttonTitle?.message}
          helperText={!errors.landingPage?.buttonTitle ? t('validations.isMaxValue', { max: 24 }) : ''}
        />
        <span className="block text-gray-400 text-sm font-light leading-5 mb-2">
          {t('form.helperText.enterYourOwnText')}
        </span>
        <MultiLanguageTextField
          name="landingPage.title1"
          label={t('pages.quizForm.titleWithIndex', { index: 1 })}
          className="mb-4"
        />
        <MultiLanguageTextField
          name="landingPage.title2"
          label={t('pages.quizForm.titleWithIndex', { index: 2 })}
          className="mb-4"
        />
        <MultiLanguageTextField
          name="landingPage.title3"
          label={t('pages.quizForm.titleWithIndex', { index: 3 })}
          className="mb-4"
          multiline
          rows={4}
        />

        <div className="">
          <Controller
            control={control} name="landingPage.backgroundImage"
            render={({ field }) => (
              <ImageUpload
                {...field}
                format={MediaFormats.Background}
                label="labels.backgroundImage"
                className="sm:w-1/2"
              />
            )}
          />
        </div>
      </div>
      <div
        className="
          w-full landscape:w-1/2 tablet:w-full laptop:w-5/12
          landscape:border-l tablet:border-l-0 laptop:border-l
          px-6
        "
        style={{
          borderColor: 'rgba(255,255,255,0.2)',
        }}
      >
        <Controller
          control={control}
          name="landingPage.image"
          render={({ field }) => (
            <ImageUpload
              {...field}
              key={imageBackgroundColor}
              format={MediaFormats.HomeScreen}
              label="labels.image"
              className="sm:w-1/2"
              backgroundColor={imageBackgroundColor}
            />
          )}
        />
        <Controller
          control={control} name="landingPage.imageBackgroundColor"
          render={({ field: { value, onChange } }) => (
            <ColorPicker
              label={t('pages.quizForm.imageBackgroundColorLabel')}
              value={value || 'rgba(255, 255, 255, 0)'}
              onChange={onChange}
            />
          )}
        />
        <div className="flex items-center mt-4">
          <span className="block text-white text-base font-semibold mr-3">{t('pages.quizForm.imageShadowEnabledLabel')}</span>
          <Controller
            control={control} name="landingPage.imageShadowEnabled"
            render={({ field: { onChange, value } }) => (
              <Toggle
                id="landingPageImageShadowEnabled"
                checked={value}
                onChange={onChange}
              />
            )}
          />
        </div>
      </div>
    </div>
  )
}

export default LandingPageForm;
